/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../app/hooks';
import { useEffect } from 'react';
import { fetchDocumentForExternalReviewThunk } from './externalReviewSlice';
import {
  fetchReviewTokenInfo,
  setCurrentSearchInReview,
  setReviewInfoFromLink,
} from '../features/Comments/commentsSlice';
import { AudienceType } from '../features/sharedcomponents/algorithm/types';

// This hook uses review_id and doc_version_id as dependencies, then sets up the document for search, just like useSearchParamnsDocument.
export const useReviewParamsToFetchUnAuthDocumentVersion = () => {
  const [searchParams] = useSearchParams();

  const documentVersionId = searchParams.get('documentVersions');
  const reviewId = searchParams.get('consultant-reviews');
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (!documentVersionId || !reviewId) return;

    void (async () => {
      try {
        // Wait until token info is fetched
        await dispatch(fetchReviewTokenInfo({ documentVersionId, reviewId }));
        // Then set review info
        dispatch(setReviewInfoFromLink({ documentVersionId, reviewId }));
        // Then set current search
        dispatch(
          setCurrentSearchInReview({
            audience: {} as AudienceType,
            howActivated: 'urlLink',
            publishedOnly: false,
            searchCategories: true,
            documentVersionId,
            keep: false,
            reviewerId: reviewId,
          })
        );
        // Finally fetch the document
        await dispatch(
          fetchDocumentForExternalReviewThunk({
            doc_version_id: documentVersionId,
            review_id: reviewId,
          })
        );
      } catch (err) {
        console.error('Error in useReview hook:', err);
      }
    })();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentVersionId, reviewId]);
};
